export const CONTACTS_SET_VIEW = 'CONTACTS_SET_VIEW';
export const CONTACT_SET_ROL_CREATED = 'CONTACT_SET_ROL_CREATED';
export const CONTACT_SET_CONTACT_TO_UPDATE = 'CONTACT_SET_CONTACT_TO_UPDATE';
export const CONTACT_SET_FORM_VIEW = 'CONTACT_SET_FORM_VIEW';
export const CONTACT_SET_CUSTOMER = 'CONTACT_SET_CUSTOMER';
export const CONTACT_SET_LAST_ROUTE = 'CONTACT_SET_LAST_ROUTE';

export enum ContactsMutations {
    SET_DIRECTORY = 'SET_DIRECTORY',
    SET_SELECTED_CONTACT_DETAILS = 'SET_SELECTED_CONTACT_DETAILS',
    SET_SELECTED_CONTACT_USER_DATA = 'SET_SELECTED_CONTACT_USER_DATA',
    SET_SELECTED_CONTACT_PRIVILEGES = 'SET_SELECTED_CONTACT_PRIVILEGES',
}
